<template>
  <div class="search searchModule">
    <header>
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="请输入您想搜索的内容"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
          v-focus="isShow"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <div class="recordLabel">
      <div class="history" v-if="historyList && historyList.length > 0">
        <p class="f14">历史记录<img @click="deleteHistory" src="/static/images/community/search-icon-delete.png"/></p>
        <ul>
          <li v-for="(item, index) in historyList" :key="index" @click="historyClick(item)">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import skinTest from '../common/skinTest'
import productList from '../common/productList'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'communitySearch',
  components: {
    skinTest,
    productList
  },
  data () {
    return {
      list: [],
      historyList: [],
      isShow: true,
      searchValue: ''
    }
  },
  mounted: function () {
    if (isWeixin()) fenxiang({path: 'communitysearch'})
    this.getData()
    if (localStorage.getItem('community-historylist') !== null && localStorage.getItem('community-historylist') !== undefined && localStorage.getItem('community-historylist') != '') {
      this.historyList = JSON.parse(localStorage.getItem('community-historylist'))
    }
  },
  destroyed: function () {
    this.$dialog.close()
    this.$toast.clear()
  },
  methods: {
    getData: function () {
    },
    cancel: function () {
      this.$router.go(-1)
    },
    search: function () {
      if (this.searchValue) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/searchword/save',
          data: {
            type: 'community',
            keyword: this.searchValue
          }
        })
        setTimeout(() => {
          this.$router.push({path: '/communitysearchresult',
            query: {
              searchval: encodeURIComponent(this.searchValue)
            }
          })
        })
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    deleteHistory: function () {
      localStorage.removeItem('community-historylist')
      this.historyList = []
    },
    historyClick: function (items) {
      this.searchValue = items
      this.search()
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.children[0].children[0].children[1].children[0].children[0].focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .search {
    background: #ffffff;
  }
  header {
    z-index: 2;
    padding:0 0.11rem 0;
    padding-right: 0.03rem;
    background: #fff;
    border-bottom: 0.1rem solid #EEEEEE;
  }
  .recordLabel {
    margin-bottom: 0.11rem;
    background: #fff;
    padding: 0.10rem 0.11rem 0.07rem;
    .history ul, .hot ul {
      display: flex;
      display: -o-flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -moz-flex;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -o-flex-wrap: wrap;
    }
    li {
      font-size: 0.12rem;
      color: #5E5E5E;
      padding: 0.06rem 0.15rem;
      background: #EEEFF4;
      border-radius: 0.15rem;
      margin-top: 0.08rem;
      margin-right: 0.1rem;
      font-weight:400;
    }
    .history {
      margin-bottom: 0.17rem;
      p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #222222;
        font-weight: 700;
        img{
          width: 0.14rem;
          height: 0.14rem;
        }
      }
    }
    .hot {
      /*margin-top: 0.15rem;*/
      margin-bottom: 0.02rem;
      p {
        display: flex;
        display: -o-flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        font-size: 0.12rem;
        color:#979797;
      }
      img{
        width: 0.1rem;
        height: 0.12rem;
        margin-left: 0.1rem;
        margin-top: 0.03rem;
      }
    }
  }
  .list {
    background: #fff;
    ul {
      background: #fff;
      li {
        padding: 0.1rem 0.11rem 0;
        display: flex;
        display: -o-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        &:last-of-type{
          padding-bottom: 0.1rem;
        }
        >img {
          width: 1.22rem;
          height: 1.22rem;
        }
        .content {
          margin-left: 0.07rem;
          paddingf-top: 0.05rem;
          >p {
            font-size:0.14rem;
            font-family:'PingFangSC';
            font-weight:400;
            color:rgba(41,41,41,1);
            line-height:0.2rem;
            height: 0.4rem;
            img {
              width: 0.19rem;
              height: 0.19rem;
              display: inline;
              position: relative;
              top: 0.04rem;
              left: 0.04rem;
            }
          }
          .evaluation {
            margin-top: 0.06rem;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            display: -webkit-flex;
            b {
              font-size: 0.11rem;
              color: #6C6C6C;
              font-weight: 400;
              &:last-of-type {
                margin-left: 0.25rem;
              }
            }
          }
          >span{
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: center;
            -webkit-align-items: center;
            -o-align-items: center;
            -moz-align-items: center;
            -ms-align-items: center;
            margin-top: 0.27rem;
            i {
              display: block;
              font-size:0.1rem;
              font-weight:400;
              color:rgba(108,108,108,1);
              line-height:14px;
              font-style: normal;
              text-decoration: line-through ;
            }
            b{
              display: block;
              color: #FC0324;
              font-size: 0.13rem;
              font-weight:600;
              line-height: 0.2rem;
              margin-right: 0.05rem;
              &:before {
                content: '￥';
                color: #FC0324;
                font-size: 0.12rem;
                line-height:17px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/communitySearch.vue